module.exports = __webpack_public_path__ + "static/escc-ac138f879df5cea7ab3eaf98eed01a36.png";